import CommonAPIService from "src/serviceHandlers/commonHandler";

export default class pdfUploadAPIservice {
  constructor(router) {
    this.api = new CommonAPIService(router);
  }

  uploadPdf(file) {
    const url = "/api/pdf/upload";
    const formData = new FormData();
    formData.append("pdf", file);
    return this.api.postFormDataCall(url, formData);
  }
}
